import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <div className="bg-[#FFF8F5] py-12">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <h1 className="font-heading text-3xl md:text-4xl font-black text-slate-900">Informativa sulla Privacy</h1>
          <p className="text-slate-500 mt-2">Ai sensi del Regolamento UE 2016/679 (GDPR)</p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-12 prose prose-slate max-w-none">
        <p className="text-sm text-slate-500 mb-8">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

        <h2 className="font-heading text-xl font-bold text-slate-900">1. Titolare del Trattamento</h2>
        <p>Il Titolare del trattamento dei dati è <strong>A.S.D. Caribbean Blue Moon Dance School</strong>, con sede in Via Ambra 19, 58100 Grosseto (GR), Italia.</p>
        <p>P.IVA: 01770860532<br/>Email/PEC: <a href="mailto:caribbean.bluemoon2025@gmail.com" className="text-[#0288D1]">caribbean.bluemoon2025@gmail.com</a><br/>Telefono: 380 159 9564</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">2. Dati Raccolti</h2>
        <p>Raccogliamo i seguenti dati personali, forniti volontariamente dall'utente:</p>
        <ul className="list-disc pl-6 space-y-1 text-slate-600">
          <li><strong>Dati di contatto:</strong> nome, cognome, email, numero di telefono</li>
          <li><strong>Dati per la spedizione:</strong> indirizzo di consegna</li>
          <li><strong>Dati di pagamento:</strong> gestiti esclusivamente da Stripe Inc. (PCI-DSS compliant). Non conserviamo dati di carte di credito</li>
          <li><strong>Dati di navigazione:</strong> cookie tecnici necessari al funzionamento del sito</li>
        </ul>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">3. Finalità del Trattamento</h2>
        <p>I dati personali sono trattati per le seguenti finalità:</p>
        <ul className="list-disc pl-6 space-y-1 text-slate-600">
          <li><strong>Evasione ordini:</strong> gestione degli acquisti, spedizione prodotti, assistenza post-vendita</li>
          <li><strong>Prenotazione lezioni:</strong> gestione delle richieste di lezione di prova gratuita</li>
          <li><strong>Richieste affitto sala:</strong> gestione delle richieste di utilizzo della sala</li>
          <li><strong>Contatto:</strong> risposta a richieste di informazioni</li>
        </ul>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">4. Base Giuridica</h2>
        <p>Il trattamento dei dati si basa su:</p>
        <ul className="list-disc pl-6 space-y-1 text-slate-600">
          <li><strong>Esecuzione contrattuale:</strong> per l'evasione degli ordini (Art. 6, par. 1, lett. b GDPR)</li>
          <li><strong>Consenso:</strong> per le richieste di prenotazione e contatto (Art. 6, par. 1, lett. a GDPR)</li>
          <li><strong>Obbligo legale:</strong> per adempimenti fiscali e contabili (Art. 6, par. 1, lett. c GDPR)</li>
        </ul>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">5. Conservazione dei Dati</h2>
        <p>I dati personali sono conservati per il tempo necessario alle finalità per cui sono raccolti:</p>
        <ul className="list-disc pl-6 space-y-1 text-slate-600">
          <li>Dati relativi agli ordini: 10 anni (obblighi fiscali)</li>
          <li>Dati di contatto e prenotazioni: 24 mesi dall'ultimo contatto</li>
        </ul>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">6. Diritti dell'Interessato</h2>
        <p>Ai sensi degli artt. 15-22 del GDPR, l'utente ha diritto a:</p>
        <ul className="list-disc pl-6 space-y-1 text-slate-600">
          <li>Accedere ai propri dati personali</li>
          <li>Richiedere la rettifica o la cancellazione dei dati</li>
          <li>Limitare od opporsi al trattamento</li>
          <li>Richiedere la portabilità dei dati</li>
          <li>Revocare il consenso in qualsiasi momento</li>
          <li>Proporre reclamo al Garante per la Protezione dei Dati Personali</li>
        </ul>
        <p>Per esercitare i propri diritti, contattare: <a href="mailto:caribbeanbluemoon2025@gmail.com" className="text-[#0288D1]">caribbeanbluemoon2025@gmail.com</a></p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">7. Cookie</h2>
        <p>Il sito utilizza esclusivamente <strong>cookie tecnici</strong> necessari al funzionamento (es. gestione del carrello). Non utilizziamo cookie di profilazione o di terze parti per finalità di marketing.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">8. Trasferimento Dati</h2>
        <p>I dati di pagamento sono gestiti da <strong>Stripe Inc.</strong> (USA), conforme al GDPR tramite Clausole Contrattuali Standard (SCC). Nessun altro dato viene trasferito al di fuori dello Spazio Economico Europeo.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">9. Sicurezza</h2>
        <p>Adottiamo misure tecniche e organizzative adeguate per proteggere i dati personali, inclusa la crittografia SSL/TLS per tutte le comunicazioni.</p>

        <div className="mt-12 pt-8 border-t border-slate-200">
          <Link to="/" className="text-[#0288D1] font-heading font-semibold hover:text-[#FF7043] transition-colors">
            ← Torna alla Home
          </Link>
        </div>
      </div>
    </div>
  );
}
